<template>
  <td>
    <template v-if="itemValue !== null">
      <span
        v-if="!isDate"
        v-text="itemValue"
      />
      <span v-else>{{ itemValue | dateFilter }}</span>
    </template>
    <span
      v-else
      v-text="$i18n.t(nullValueKey||'dashboard.table.empty')"
      style="opacity: 0.4"
    />
  </td>
</template>

<script>
export default {
  props: {
    item: {
      required: true
    },
    translate: {
      type: Boolean,
      default: false
    },
    isDate: {
      type: Boolean,
      default: false
    },
    nullValueKey: {
      type: String,
      required: false
    },
    isContact: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    itemValue() {
      if (Array.isArray(this.item)) {
        return this.item.length > 0
          ? this.item
              .map(el => {
                return this.getTranslation(el);
              })
              .join(', ')
          : null;
      } else if (this.isNotTranslatedObjectValue(this.item)) {
        return JSON.stringify(this.item)
          .replace(/["{}]/g, '')
          .replace(',', ', ')
          .replace('from', this.$i18n.t('default.from'))
          .replace('to', this.$i18n.t('default.to'));
      } else if (this.isBoolean(this.item)) {
        return this.$i18n.t(`default.${this.item}`);
      } else if (this.item === null) {
        return null;
      } else if (this.isContact) {
        return this.item.replaceAll(',', ', ');
      } else {
        return this.getTranslation(this.item);
      }
    }
  },
  methods: {
    getTranslation(item) {
      return this.translate ? item && item[this.$i18n.locale] ? item[this.$i18n.locale] : null : item;
    },
    isBoolean(item) {
      return (
        item !== null && item !== undefined && item.constructor === Boolean
      );
    },
    isNotTranslatedObjectValue(item) {
      return !!item && item.constructor === Object && !this.translate;
    }
  }
};
</script>

<style lang="scss"></style>
